
import React, { useState, useEffect } from "react";
import UnifiedForm from "../../molecules/PickupDropMap/PickupDropMap";

const Tabs = (props) => {
    const [activeTab, setActiveTab] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    useEffect( () => {
        let searchData =  props?.searchData;
        if(searchData) {
            let searchType = searchData['search-type'] || "";
            // console.log(searchType)
            if (searchType) {
                switch (searchType) {
                    default:
                    case 'local':
                        setActiveTab('tab2');
                        break;
                    case 'airport':
                        setActiveTab('tab1');
                        break;
                    case 'out_station':
                        setActiveTab('tab3');
                        break;
                    case 'self_drive':
                        setActiveTab('tab4');
                        break;
                }
            } else {
                setActiveTab('tab2');
            }
        } else {
            setActiveTab('tab2');
        }
    } , [])

    const tabs = [
        { id: "tab2", label: "Local", component: <UnifiedForm activeTab={activeTab ?? "tab2"} modifySearch={props.modifySearch} searchData={props.searchData} /> },
        { id: "tab1", label: "Airport Transfer", component: <UnifiedForm activeTab={activeTab ?? "tab1"} modifySearch={props.modifySearch} searchData={props.searchData} /> },
        { id: "tab3", label: "Intercity", component: <UnifiedForm activeTab={activeTab ?? "tab3"} modifySearch={props.modifySearch} searchData={props.searchData} /> },
        { id: "tab4", label: "Self Drive", component: <UnifiedForm activeTab={activeTab ?? "tab4"} modifySearch={props.modifySearch} searchData={props.searchData} /> }
    ];

    return (
        <div className="hero-section--item-container">
            {!isMobile ? (
                <>
                    <div className="hero-section--item-container-tabs">
                        {tabs.map(({ id, label }) => (
                            <button
                                key={id}
                                className={activeTab === id ? "active" : ""}
                                onClick={() => handleTabClick(id)}
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                    <div className="hero-section--item-container-tab-content">
                        {tabs.find(tab => tab.id === activeTab)?.component}
                    </div>
                </>
            ) : (
                <div className="accordion">
                    {tabs.map(({ id, label, component }) => (
                        <div className="accordion-item" key={id}>
                            <div
                                className="accordion-item-header"
                                onClick={() => setActiveTab(id === activeTab ? null : id)}
                            >
                                {label}
                            </div>
                            <div className={`accordion-item-content ${activeTab === id ? "active" : ""}`}>
                                {activeTab === id && component}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Tabs;